import { gql } from '@apollo/client';
import CompanyBasicSettingsFields from "../../../fragments/CompanyAdminContext/BasicSettings";

const UPDATE_COMPANY_BASIC_SETTINGS = gql`
  mutation UpdateCompanyBasicSettings(
    $settings: CompanyBasicSettingsInput!
  ) {
    companyAdminContext {
      settings {
        updateCompanyBasicSettings(settings: $settings) {
          ...CompanyBasicSettingsFields
        }
      }
    }
  }
  ${CompanyBasicSettingsFields}
`;

export default UPDATE_COMPANY_BASIC_SETTINGS;
